// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallMemberPermissionsPopup__wrapper-bd5637 {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.CallMemberPermissionsPopup__title-c98931 {
  font: var(--font-subtitle-1);
  color: var(--base-70);
  margin: 0 0 0 24px;
  letter-spacing: var(--font-spacing-subtitle-1);
}

.CallMemberPermissionsPopup__divider-de03b2 {
  height: 1px;
  display: flex;
  margin: 0 24px 24px 24px;
  box-sizing: border-box;
  background: var(--base-20);
}

.CallMemberPermissionsPopup__divider-footer-ea1edd {
  margin: 16px 24px;
}

.CallMemberPermissionsPopup__member-a3d44c {
  padding: 24px;
}

.CallMemberPermissionsPopup__add-button-cd0030 {
  width: fit-content;
  margin: auto 24px 24px auto;
}

.CallMemberPermissionsPopup__delete-button-aa18ec {
  display: flex;
  align-items: center;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  padding: 12px 24px;
  cursor: pointer;
}

.CallMemberPermissionsPopup__delete-icon-bb5ef5 {
  margin-inline-end: 24px;
  fill: var(--color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallMemberPermissionsPopup/CallMemberPermissionsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,8CAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,wBAAA;EACA,sBAAA;EACA,0BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,iCAAA;AACF","sourcesContent":[".wrapper {\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  font: var(--font-subtitle-1);\n  color: var(--base-70);\n  margin: 0 0 0 24px;\n  letter-spacing: var(--font-spacing-subtitle-1);\n}\n\n.divider {\n  height: 1px;\n  display: flex;\n  margin: 0 24px 24px 24px;\n  box-sizing: border-box;\n  background: var(--base-20);\n}\n\n.divider-footer {\n  margin: 16px 24px;\n}\n\n.member {\n  padding: 24px;\n}\n\n.add-button {\n  width: fit-content;\n  margin: auto 24px 24px auto;\n}\n\n.delete-button {\n  display: flex;\n  align-items: center;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  padding: 12px 24px;\n  cursor: pointer;\n}\n\n.delete-icon {\n  margin-inline-end: 24px;\n  fill: var(--color-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CallMemberPermissionsPopup__wrapper-bd5637`,
	"title": `CallMemberPermissionsPopup__title-c98931`,
	"divider": `CallMemberPermissionsPopup__divider-de03b2`,
	"divider-footer": `CallMemberPermissionsPopup__divider-footer-ea1edd`,
	"dividerFooter": `CallMemberPermissionsPopup__divider-footer-ea1edd`,
	"member": `CallMemberPermissionsPopup__member-a3d44c`,
	"add-button": `CallMemberPermissionsPopup__add-button-cd0030`,
	"addButton": `CallMemberPermissionsPopup__add-button-cd0030`,
	"delete-button": `CallMemberPermissionsPopup__delete-button-aa18ec`,
	"deleteButton": `CallMemberPermissionsPopup__delete-button-aa18ec`,
	"delete-icon": `CallMemberPermissionsPopup__delete-icon-bb5ef5`,
	"deleteIcon": `CallMemberPermissionsPopup__delete-icon-bb5ef5`
};
module.exports = ___CSS_LOADER_EXPORT___;
